// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Import server Config
import apiLink from '@configs/serverConfig'

// ** Axios Imports
import axios from 'axios'

export const getExpectedCreditPayments = createAsyncThunk('appFinances/getExpectedCreditPayments', async params => {
    const response = await axios.get(apiLink('getCreditsList', params))
    return response.data.credits
})
export const getExpectedRentPayments = createAsyncThunk('appFinances/getExpectedRentPayments', async params => {
    const response = await axios.get(apiLink('getRentsList', params))
    return response.data.rents
})

// Related payments
export const getRelatedPayments = createAsyncThunk('appFinances/getRelatedPayments', async params => {
    const response = await axios.get(apiLink('getRelatedPayments', params))
    return response.data
})
export const addPaymentRelation = createAsyncThunk('appFinances/addPaymentRelation', async params => {
    const response = await axios.post(apiLink('addPaymentRelation', params))
    return response.data
})
export const deleteRelatedPayment = createAsyncThunk('appFinances/deleteRelatedPayment', async (params) => {
    const response = await axios.delete(apiLink('deleteRelatedPayment', params))
    return response.data
})

export const getCustomersList = createAsyncThunk('appFinances/getCustomersList', async () => {
   const params = {active: true, sort_list: 'first_name', sort_order: 'ASC', rows: 1000, blacklist: false}
   const response = await axios.get(apiLink('getCustomersShortList', params))
   return response.data.customers
})

export const getExpectedRentVisits = createAsyncThunk('appFinances/getExpectedRentVisits', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/rent/expected-visits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getExpectedRentPercentVisits = createAsyncThunk('appFinances/getExpectedRentPercentVisits', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/rent/expected-percent-visits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getExpiredRentVisits = createAsyncThunk('appFinances/getExpiredRentVisits', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/rent/expired-visits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getExpiredRentPercentVisits = createAsyncThunk('appFinances/getExpiredRentPercentVisits', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/rent/expired-percent-visits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getExpectedCreditVisits = createAsyncThunk('appFinances/getExpectedCreditVisits', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/credit/expected-visits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getExpiredCreditVisits = createAsyncThunk('appFinances/getExpiredCreditVisits', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/credit/expired-visits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getExpectedPromissoryNoteVisits = createAsyncThunk('appFinances/getExpectedPromissoryNoteVisits', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/promissory-notes/expected-visits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getExpiredPromissoryNoteVisits = createAsyncThunk('appFinances/getExpiredPromissoryNoteVisits', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/promissory-notes/expired-visits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})

export const getExpectedRentVisitsPredictions = createAsyncThunk('appFinances/getExpectedRentVisitsPredictions', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/rent/expected-visits-predictions?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getExpectedCreditVisitsPredictions = createAsyncThunk('appFinances/getExpectedCreditVisitsPredictions', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/credit/expected-visits-predictions?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getRentEvents = createAsyncThunk('appFinances/getRentEvents', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/rent/events?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getRentMissedVisits = createAsyncThunk('appFinances/getRentMissedVisits', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/rent/missed-visits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getCreditMissedVisits = createAsyncThunk('appFinances/getCreditMissedVisits', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/credit/missed-visits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getRentDebtors = createAsyncThunk('appFinances/getRentDebtors', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/rent/debtors?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getCreditDebtors = createAsyncThunk('appFinances/getCreditDebtors', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/credit/debtors?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getDebtorsWithoutActiveServices = createAsyncThunk('appFinances/getDebtorsWithoutActiveServices', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/finance/debtors-without-active-services?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getDebtorsActiveServices = createAsyncThunk('appFinances/getDebtorsActiveServices', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/finance/debtors-active-services?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getDebtorsDisabledServices = createAsyncThunk('appFinances/getDebtorsDisabledServices', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/finance/debtors-disabled-services?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getDebtorsClosedRent = createAsyncThunk('appFinances/getDebtorsClosedRent', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/finance/debtors-closed-rent?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})

export const exportPaymentsToEXCEL = createAsyncThunk('appFinances/exportPaymentsToEXCEL', async (data) => {
    const response = await axios.post(`https://api.mfauto.com.ua/finances/export-payments-to-excel?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})

export const getSystemPayments = createAsyncThunk('appFinances/getSystemPayments', async params => {
    params.page = params.page === 0 ? 0 : params.page - 1

    const response = await axios.get(apiLink('getPaymentsList', params))
    return {
        params,
        payments: response.data.response,
        totalPages: response.data.total_elements
    }
})

// ** Payments
export const addPayment = createAsyncThunk('appFinances/addPayment', async (data) => {
    return await axios.post(apiLink('addPayment'), data)
})
export const removePayment = createAsyncThunk('appFinances/removePayment', async (id) => {
    const response = await axios.delete(apiLink({name: 'removePayment', value: id}, {type: 'COMPANY'}))
    return response.data
})

// ** Payment settings list/subtypes
export const getPaymentSubTypes = createAsyncThunk('appFinances/getPaymentSubTypes', async () => {
    const response = await axios.get(apiLink('getPaymentSubTypes'))
    return response.data
})
export const addPaymentSubType = createAsyncThunk('appFinances/addPaymentSubType', async (data) => {
    return await axios.post(apiLink('addPaymentSubTypes'), data)
})
export const updatePaymentSubTypes = createAsyncThunk('appFinances/updatePaymentSubTypes', async (data) => {
    const subtype_id = data.id
    delete data.id
    const response = await axios.put(apiLink({name: 'updatePaymentSubTypes', value: subtype_id}), data)
    return response.data
})
export const removePaymentSubTypes = createAsyncThunk('appFinances/removePaymentSubTypes', async (id) => {
    const response = await axios.delete(apiLink({name: 'removePaymentSubTypes', value: id}))
    return response.data
})

export const approvePayment = createAsyncThunk('appFinances/approvePayment', async (data) => {    
    const  response = await axios.post(apiLink({name: 'approvePayment', value: data.payment_id}), data)
    return {response, data}
})

export const getPaymentDetails = createAsyncThunk('appFinances/getPaymentDetails', async (data) => {    
    const response = await axios.post(`https://api.mfauto.com.ua/finances/payment-details?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})

// ** Notifications
export const getNofiticationsExpected = createAsyncThunk('appFinances/getNofiticationsExpected', async data => {   
    const response = await axios.post(`https://api.mfauto.com.ua/notifications/expected-visits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getNofiticationsExpired = createAsyncThunk('appFinances/getNofiticationsExpired', async data => {   
    const response = await axios.post(`https://api.mfauto.com.ua/notifications/expired-visits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getNofiticationsDebtors = createAsyncThunk('appFinances/getNofiticationsDebtors', async data => {   
    const response = await axios.post(`https://api.mfauto.com.ua/notifications/debtors-visits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getNofiticationsReturnsPickups = createAsyncThunk('appFinances/getNofiticationsReturnsPickups', async data => {   
    const response = await axios.post(`https://api.mfauto.com.ua/notifications/returns-pickups-visits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})

// ** Accounts report
export const financeDailyReport = createAsyncThunk('appFinances/financeDailyReport', async data => {   
    const response = await axios.post(`https://api.mfauto.com.ua/stats/accounts?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})

// ** Balances total by params
export const getPaymentsTotal = createAsyncThunk('appFinances/getPaymentsTotal', async data => {   
    const response = await axios.post(`https://api.mfauto.com.ua/finances/total?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})

// ** Car payments
export const getCarPayments = createAsyncThunk('appFinances/getCarPayments', async data => {   
    const response = await axios.post(`https://api.mfauto.com.ua/finance/get/car-payments?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})

export const financePaymentsEntityReport = createAsyncThunk('appFinances/financePaymentsEntityReport', async data => {   
    const response = await axios.post(`https://api.mfauto.com.ua/finances/entity/payments?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})

// ** List of cars
export const getCompanyPaymentCars = createAsyncThunk('appFinances/getCompanyPaymentCars', async () => {
    const params = {sort_list: 'id', sort_order: 'ASC', rows: 1000}
    const response = await axios.get(apiLink('getCarsShortList', params))
    return response.data.cars
})

// ** Daily summary report request
export const getCustomSystemPayments = createAsyncThunk('appFinances/getSystemPayments', async params => {
    params.page = params.page === 0 ? 0 : params.page - 1

    const token = params.token
    delete params.token

    const response = await axios.post(`https://api.mfauto.com.ua/report/daily-summary?env=${process.env.REACT_APP_NODE_ENV}`, { token, params })
    return {
        params,
        payments: response.data.response,
        totalPages: response.data.total_elements
    }
})

export const getMaintenanceDepositPayments = createAsyncThunk('appFinances/getSystemPayments', async params => {
    params.page = params.page === 0 ? 0 : params.page - 1

    const token = params.token
    delete params.token

    const response = await axios.post(`https://api.mfauto.com.ua/report/maintenance-deposit-balance?env=${process.env.REACT_APP_NODE_ENV}`, { token, params })

    return {
        params,
        payments: response.data.response,
        totalPages: response.data.total_elements,
        totals: response.data.totals,
        debts: response.data.debt,
        debts_balance: response.data.debts_balance
    }
})

// ** Location groups report (car_info.location grouped into reporting "location groups" <-> payment_account)
export const getLocationGroupsOptions = createAsyncThunk('appFinances/getLocationGroupsOptions', async (data) => {
    const response = await axios.post(`https://api.mfauto.com.ua/report/location/options?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const saveLocationGroups = createAsyncThunk('appFinances/saveLocationGroups', async (data) => {
    const response = await axios.post(`https://api.mfauto.com.ua/report/location/groups/save?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const exportLocationGroupsReport = createAsyncThunk('appFinances/exportLocationGroupsReport', async (data) => {
    const response = await axios.post(`https://api.mfauto.com.ua/report/location/report/export?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})

// ** Returns pickups
export const getRentReturns = createAsyncThunk('appFinances/getRentReturns', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/rents/returns/visits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getRentReturnsTomorrow = createAsyncThunk('appFinances/getRentReturnsTomorrow', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/rents/returns/tomorrow-visits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})
export const getRentScheduledPlanned = createAsyncThunk('appFinances/getRentScheduledPlanned', async data => {
    const response = await axios.post(`https://api.mfauto.com.ua/rents/scheduled-planned-visits?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
})

const getLocalStorageFinanceFetchData = () => {
    const storage = window.localStorage.getItem('finances')        
    return storage !== null ? JSON.parse(storage) : {
        expected: 0,
        expired: 0,
        debtors: 0,
        returnsPickups: 0,
        fetch: null
    }
}

export const appFinancesSlice = createSlice({
    name: 'appFinances',
    initialState: {
        expected: [],
        expired: [],
        debtors: [],
        quantity: getLocalStorageFinanceFetchData(),
        payments: [],
        total: 1,
        totals: [],
        debts: [],
        debts_balance: [],
        params: {},
        data: [],
        dates: [],
        distances: false
    },
    reducers: {
        changeExpectedQuantity: (state, action) => {
            state.quantity.expected = action.payload

            const storage = window.localStorage.getItem('finances')      
            const storageParse = storage !== null ? JSON.parse(storage) : {}

            localStorage.setItem('finances', JSON.stringify({                
                expected: action.payload,
                expired: storageParse?.expired,
                debtors: storageParse?.debtors,
                returnsPickups: storageParse?.returnsPickups,
                fetch: storageParse?.fetch
            }))            
        },
        changeExpiredQuantity: (state, action) => {
            state.quantity.expired = action.payload
            
            const storage = window.localStorage.getItem('finances')      
            const storageParse = storage !== null ? JSON.parse(storage) : {}
            localStorage.setItem('finances', JSON.stringify({                
                expected: storageParse?.expected,
                expired: action.payload,
                debtors: storageParse?.debtors,
                returnsPickups: storageParse?.returnsPickups,
                fetch: storageParse?.fetch
            }))            
        },
        changeDebtorsQuantity: (state, action) => {
            state.quantity.debtors = action.payload
            
            const storage = window.localStorage.getItem('finances')      
            const storageParse = storage !== null ? JSON.parse(storage) : {}
            localStorage.setItem('finances', JSON.stringify({                
                expected: storageParse?.expected,
                expired: storageParse?.expired,
                debtors: action.payload,
                returnsPickups: storageParse?.returnsPickups,
                fetch: storageParse?.fetch
            }))            
        },
        changeReturnsPickupsQuantity: (state, action) => {
            state.quantity.returnsPickups = action.payload
            
            const storage = window.localStorage.getItem('finances')      
            const storageParse = storage !== null ? JSON.parse(storage) : {}
            localStorage.setItem('finances', JSON.stringify({                
                expected: storageParse?.expected,
                expired: storageParse?.expired,
                debtors: storageParse?.debtors,
                returnsPickups: action.payload,
                fetch: storageParse?.fetch
            }))            
        },
        registerQuantityFetch: (state, action) => {
            state.quantity.fetch = action.payload
            
            const storage = window.localStorage.getItem('finances')      
            const storageParse = storage !== null ? JSON.parse(storage) : {}
            localStorage.setItem('finances', JSON.stringify({                
                expected: storageParse?.expected,
                expired: storageParse?.expired,
                debtors: storageParse?.debtors,
                returnsPickups: storageParse?.returnsPickups,
                fetch: action.payload
            })) 
        }
    },
    extraReducers: builder => {
        builder
        .addCase(getSystemPayments.pending, (state) => {
            state.payments = []                        
        })
        .addCase(getSystemPayments.fulfilled, (state, action) => {
            state.payments = action.payload.payments
            state.params = action.payload.params
            state.total = action.payload.totalPages
            state.totals = action.payload.totals !== undefined ? action.payload.totals : []
            state.debts = action.payload.debts !== undefined ? action.payload.debts : []
            state.debts_balance = action.payload.debts_balance !== undefined ? action.payload.debts_balance : []
        })       
        .addCase(approvePayment.fulfilled, (state, action) => {     
            if (action.payload.response.status === 200) {
                const updatedPayments = state.payments.map(payment => { 
                    if (payment.payment_id === action.payload.data.payment_id) {                    
                        return {...payment, approve: {...payment.approve, ...action.payload.data}}
                    } else {                    
                        return {...payment}
                    }                
                })
                state.payments = [...updatedPayments]
            }
        }) 
        .addCase(getCarPayments.fulfilled, (state, action) => {
            state.data = action.payload.list
            state.dates = action.payload.dates
            state.distances = action.payload.distances
        })
    }
})
export const {
    changeExpectedQuantity,
    changeExpiredQuantity,
    changeDebtorsQuantity,
    changeReturnsPickupsQuantity,
    registerQuantityFetch
} = appFinancesSlice.actions

export default appFinancesSlice.reducer
